export default {"src":"/_next/static/media/value.56bd883c.svg","height":103,"width":356,"blurWidth":0,"blurHeight":0};